import type { SoldOutItem } from '../../types/dashboard'

export default function SoldOutPanel({ items }: { items: SoldOutItem[] }) {
    return (
        <div className="chart-panel" style={{ height: '100%' }}>
            <div className="chart-panel-title">Sold the Last Of... (Today)</div>
            {items.length === 0
                ? <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--color-text-tertiary)' }}>No items sold out completely today</div>
                : (
                    <div className="chart-panel-content">
                        <table className="top-sellers-table">
                            <thead><tr><th>Product</th><th>Variant (Color / Size)</th><th>SKU</th></tr></thead>
                            <tbody>
                                {items.map((s, i) => (
                                    <tr key={i}>
                                        <td>
                                            <div className="brand">{s.brand}</div>
                                            <div>{s.description}</div>
                                        </td>
                                        <td>{s.color && s.size ? `${s.color} / ${s.size}` : s.color ? s.color : s.size ? s.size : '-'}</td>
                                        <td style={{ color: 'var(--color-text-tertiary)' }}>{s.prodNo}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
        </div>
    )
}
